import { PaletteMode } from '@mui/material';
import { ChronosphereColorPalette, grey, unityGrey } from '../colors';
import { GetThemeOptions } from '../../theme';

export const defaultColor = (mode: PaletteMode, opts: GetThemeOptions): ChronosphereColorPalette => {
  if (opts.panwRebrandStubYear) {
    return mode === 'light'
      ? {
          main: unityGrey[400],
          highContrast: unityGrey[700],
          lowContrast: unityGrey[100],
        }
      : {
          main: unityGrey[400],
          highContrast: unityGrey[100],
          lowContrast: unityGrey[800],
        };
  }

  return mode === 'light'
    ? {
        main: grey[400],
        highContrast: grey[700],
        lowContrast: grey[150],
      }
    : {
        main: grey[400],
        highContrast: grey[150],
        lowContrast: grey[800],
      };
};
